import { CalendarIcon } from "@radix-ui/react-icons";
import { DateRange } from "react-day-picker";

import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn, stringToDateRange } from "@/lib/utils";
import { OptionsContext } from "@/provider/options-provider";
import { useContext, useEffect, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { FaLongArrowAltRight } from "react-icons/fa";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

export function DateRangePicker({
  className,
  form,
  onSubmit,
}: {
  className?: React.ComponentProps<"div">["className"];
  form: UseFormReturn<
    {
      ticker?: string | undefined;
      searchText?: string | undefined;
      dateRange?:
        | {
            from?: Date;
            to?: Date;
          }
        | undefined;
    },
    any,
    undefined
  >;
  onSubmit: () => void;
}) {
  const { searchOptions, setSearchOptions } = useContext(OptionsContext);
  const [selectValue, setSelectValue] = useState<string>(
    searchOptions.dateRangeString!,
  );
  const date = searchOptions.dateRange;
  const setDate = (d: DateRange | undefined) => {
    setSearchOptions({
      ...searchOptions,
      dateRange: d,
    });
    setSelectValue("Custom");
  };
  useEffect(() => {
    setSelectValue(searchOptions.dateRangeString!);
  }, [searchOptions.dateRangeString]);

  const savePeriod = async (value: string) => {
    await fetch("/api/user", {
      method: "POST",
      body: JSON.stringify({ ...searchOptions, dateRangeString: value }),
    });
  };

  return (
    <div className={cn("grid gap-2", className)}>
      <Popover>
        <div className="flex flex-row justify-between lg:w-56">
          <Select
            value={selectValue}
            onValueChange={async (value) => {
              if (value === "Custom") {
                return;
              }

              const newDateRange = stringToDateRange(value);

              setSearchOptions({
                ...searchOptions,
                dateRange: newDateRange,
                dateRangeString: value,
              });

              form.setValue("dateRange", newDateRange);
              // if (form.getValues("searchText") || form.getValues("ticker")) {
              //   form.handleSubmit(onSubmit)();
              // }
              setSelectValue(value);
              await savePeriod(value);
            }}
          >
            <SelectTrigger className="rounded-none rounded-l-md">
              <SelectValue placeholder="Select" className="" />
            </SelectTrigger>
            <SelectContent position="popper">
              <SelectItem value="1 Week">1 Week</SelectItem>
              <SelectItem value="2 Weeks">2 Weeks</SelectItem>
              <SelectItem value="1 Month">1 Month</SelectItem>
              <SelectItem value="3 Months">3 Months</SelectItem>
              <SelectItem value="6 Months">6 Months</SelectItem>
              <SelectItem value="1 Year">1 Year</SelectItem>
              <SelectItem value="5 Years">5 Years</SelectItem>
              <SelectItem value="10 Years">10 Years</SelectItem>
              <SelectItem disabled value="Custom">
                <div className="flex flex-row items-center gap-6">
                  <p className="italic text-muted-foreground"> Custom </p>
                  <FaLongArrowAltRight />
                </div>
              </SelectItem>
            </SelectContent>
            <PopoverTrigger
              asChild
              tabIndex={-1}
              className="rounded-none rounded-r-md"
            >
              <Button
                id="date"
                variant={"outline"}
                className={cn(
                  "ml-1 w-fit justify-start text-left font-normal",
                  !date && "text-muted-foreground",
                )}
              >
                <CalendarIcon className="h-4 w-4" />
              </Button>
            </PopoverTrigger>
          </Select>
        </div>
        <PopoverContent
          className="flex w-auto flex-col space-y-2 p-2"
          align="start"
        >
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={date?.from}
            selected={date}
            onSelect={setDate}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
